import { __awaiter, __extends, __generator, __spreadArrays } from "tslib";
import * as React from 'react';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as classnames from 'classnames';
import { Checkbox } from '../../primitives/checkbox/checkbox';
import { DeprecatedText } from '../../deprecated-typography';
import { debounce } from '@wix/answers-lib';
import { NeutralMessageBox, TinyLoader } from '../../primitives';
import { SearchContainer } from '../search-container';
import { Button } from '../../new-libby/core/button/index';
import { Text } from '../../new-libby';
export var CheckboxGroupKey = 'checkbox-group';
var MAX_VALUES = 50;
var translationPrefix = "common.libby.checkbox-group";
var CheckboxGroup = /** @class */ (function (_super) {
    __extends(CheckboxGroup, _super);
    function CheckboxGroup() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.minItemsForSearch = _this.props.minItemsForSearch || 10;
        _this.state = {
            isScrolled: false,
            searchTerm: '',
            filteredIds: [],
            sortedIds: [],
            isLoading: false,
        };
        _this.onAsyncSearch = debounce(function (term) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, ((_a = this.props.asyncSearchItems) === null || _a === void 0 ? void 0 : _a.onSearch(term))];
                    case 1:
                        _b.sent();
                        this.setState({ isLoading: false });
                        return [2 /*return*/];
                }
            });
        }); }, 400);
        _this.tp = function (key, params) {
            return _this.props.t(translationPrefix + "." + key, params);
        };
        _this.componentDidMount = function () {
            if (_this.props.sortItemsBySelection) {
                var sortedIds = __spreadArrays(_this.props.items).sort(function (a, b) {
                    var aNum = Number(_this.props.value.get(a.id)) || 0;
                    var bNum = Number(_this.props.value.get(b.id)) || 0;
                    return bNum - aNum;
                })
                    .map(function (e) { return e.id; });
                _this.setState({ sortedIds: sortedIds });
            }
            var hasHeaders = _this.props.items.findIndex(function (item) { return item.isHeader; }) >= 0;
            if (hasHeaders) {
                _this.setState({ hasHeaders: hasHeaders });
            }
        };
        _this.valueChangeHandler = function (id) { return function (newVal) {
            var map = new Map(_this.props.value.entries());
            map.set(id, newVal);
            _this.props.onChange(map);
        }; };
        _this.handleScroll = function (e) {
            var state = _this.state;
            if (e.target.scrollTop > 0 && !state.isScrolled) {
                _this.setState({ isScrolled: true });
            }
            else if (e.target.scrollTop === 0 && state.isScrolled) {
                _this.setState({ isScrolled: false });
            }
        };
        _this.renderCheckboxListItem = function (item, disabledState) {
            var _a;
            var value = _this.props.value.get(item.id) || !!((_a = _this.props.asyncSearchItems) === null || _a === void 0 ? void 0 : _a.selected.find(function (a) { return a.id === item.id; }));
            var cn = classnames('checkboxes-list-item', { disabled: !!disabledState });
            if (value === undefined) {
                // tslint:disable-next-line:no-unused-expression
                console.warn("CheckboxGroup failed to render an item with id " + item.id + ". Value map must contain all item ids");
            }
            return value !== undefined && !item.isHeader ? (React.createElement("li", { className: cn, key: item.id },
                React.createElement(Checkbox, { className: 'item-checkbox', disabled: item.disabled || disabledState, value: value, onChange: _this.valueChangeHandler(item.id) },
                    React.createElement("div", { className: 'checkbox-label' }, item.customElement || item.label)))) : item.isHeader ? _this.renderHeader(item) : null;
        };
        _this.renderHeader = function (item) { return (React.createElement("div", { className: 'checkbox-group-header', key: item.id },
            React.createElement(Text, { type: 'ht', color: 't30' }, item.label))); };
        _this.getSelectedCount = function () {
            var asyncSearchItems = _this.props.asyncSearchItems;
            var selectedIds = asyncSearchItems ? asyncSearchItems === null || asyncSearchItems === void 0 ? void 0 : asyncSearchItems.selected.map(function (item) { return item.id; }) : [];
            var allItems = asyncSearchItems ? __spreadArrays(asyncSearchItems.selected, _this.props.items.filter(function (item) { return !selectedIds.includes(item.id); })) : _this.props.items;
            return allItems.filter(function (item) { return !!_this.props.value.get(item.id) || selectedIds.includes(item.id); }).length;
        };
        _this.renderCheckboxes = function () {
            var props = _this.props;
            var asyncSearchItems = _this.props.asyncSearchItems;
            var checkedCount = _this.getSelectedCount();
            var maxLimitReached = (props.maxSelections && checkedCount >= props.maxSelections);
            var minLimitReached = props.minSelections && checkedCount <= props.minSelections;
            var selectedIds = asyncSearchItems ? asyncSearchItems.selected.map(function (item) { return item.id; }) : [];
            var allItems = asyncSearchItems ? __spreadArrays(asyncSearchItems.selected, props.items.filter(function (item) { return !selectedIds.includes(item.id); })) : props.items;
            var filteredItems = allItems.filter(function (item) {
                return item.label.toLowerCase().indexOf(_this.state.searchTerm.toLowerCase()) > -1;
            });
            var sortedItems = props.sortItemsBySelection ?
                _this.state.sortedIds.reduce(function (acc, e) {
                    acc.push.apply(acc, filteredItems.filter(function (item) { return item.id === e; }));
                    return acc;
                }, []) : filteredItems;
            var items = sortedItems.map(function (item) {
                var isUnchecked = props.value.get(item.id) === false;
                var isDisabled = (isUnchecked && maxLimitReached) || (!isUnchecked && minLimitReached);
                var disabledState = isDisabled ?
                    maxLimitReached ?
                        (props.maxSelectionsText || _this.tp('max-limit-reached', { value: props.maxSelections || MAX_VALUES }))
                        : minLimitReached ? (props.minSelectionsText || true) : false : false;
                return _this.renderCheckboxListItem(item, disabledState);
            });
            var maybeEmptyState = !items.length && _this.state.searchTerm && !_this.state.isLoading ? (React.createElement("div", { className: 'empty-state-item' },
                React.createElement(Text, { type: 'ht', color: 't20', html: _this.tp('empty-state-title', { value: _this.state.searchTerm }) }),
                React.createElement(Text, { type: 'ts', color: 't40' }, _this.tp('empty-state-subtitle')))) : null;
            var maybeLoader = (!allItems.length && !!asyncSearchItems && !_this.state.searchTerm) || _this.state.isLoading ? (React.createElement("div", { className: 'loader-container' },
                React.createElement(TinyLoader, null),
                React.createElement(Text, { className: 'loading-title', type: 'ts', color: 't40' }, _this.tp('loading')))) : null;
            var moreSearchResults = !_this.state.isLoading && asyncSearchItems &&
                !_this.state.searchTerm && asyncSearchItems.totalValues > filteredItems.length ? (React.createElement("div", { className: 'more-search-values-container' },
                React.createElement(Text, { className: 'more-search-results', type: 'ts', color: 't40' }, _this.tp('more-search-results', { count: asyncSearchItems.totalValues - filteredItems.length })))) : null;
            return (React.createElement("ul", { className: 'checkboxes-list', onScroll: _this.handleScroll },
                !_this.state.isLoading ? items : null,
                maybeEmptyState,
                maybeLoader,
                moreSearchResults));
        };
        _this.onSearchTermChange = function (term) {
            _this.setState({ searchTerm: term });
            if (_this.props.asyncSearchItems) {
                _this.setState({ isLoading: true });
                _this.onAsyncSearch(term);
            }
        };
        _this.allSelected = function () {
            var _a = _this.props, maxSelections = _a.maxSelections, items = _a.items, ignoredItemsIds = _a.ignoredItemsIds, value = _a.value;
            if (ignoredItemsIds) {
                var ignoredUncheckedItemsCount = items.filter(function (item) {
                    return ignoredItemsIds.includes(item.id) && !value.get(item.id);
                }).length;
                return (_this.getSelectedCount() === maxSelections
                    || _this.getSelectedCount() + ignoredUncheckedItemsCount === items.length);
            }
            return (_this.getSelectedCount() === maxSelections || _this.getSelectedCount() === items.length);
        };
        _this.onDeselect = function () {
            var _a = _this.props, value = _a.value, onChange = _a.onChange, minSelections = _a.minSelections, ignoredItemsIds = _a.ignoredItemsIds;
            var valEntries = Array.from(value.entries());
            var newEntries = valEntries.map(function (_a, idx) {
                var k = _a[0];
                if (ignoredItemsIds && ignoredItemsIds.includes(k)) {
                    return ([k, !!valEntries[idx][1]]);
                }
                return ([k, (minSelections && idx < minSelections) || false]);
            });
            onChange(new Map(newEntries));
        };
        _this.onToggleAllSelected = function () {
            var _a = _this.props, value = _a.value, maxSelections = _a.maxSelections, items = _a.items, onChange = _a.onChange, ignoredItemsIds = _a.ignoredItemsIds;
            var valEntries = Array.from(value.entries());
            // this is easy, turn all off
            if (_this.allSelected()) {
                if (_this.props.onUncheckAll) {
                    _this.props.onUncheckAll();
                }
                else {
                    _this.onDeselect();
                }
            }
            else {
                // we need to turn on the max we can
                var selectedCount = _this.getSelectedCount();
                var itemsToTurnOnCount = (maxSelections || items.length) - selectedCount;
                var itemsTurnedOff = valEntries
                    .filter(function (_a) {
                    var v = _a[1];
                    return !v;
                })
                    .map(function (_a) {
                    var k = _a[0];
                    return k;
                });
                var itemsToTurnOn = itemsTurnedOff.slice(0, itemsToTurnOnCount);
                var newValue_1 = new Map(value);
                if (ignoredItemsIds) {
                    itemsToTurnOn.forEach(function (item) {
                        if (!ignoredItemsIds.includes(item)) {
                            newValue_1.set(item, true);
                        }
                    });
                }
                else {
                    itemsToTurnOn.forEach(function (item) { return newValue_1.set(item, true); });
                }
                onChange(newValue_1);
            }
        };
        _this.renderSelectAllHeader = function () {
            var state = _this.state;
            var valuesArr = Array.from(_this.props.value.values());
            var selectedCount = valuesArr.filter(function (v) { return !!v; });
            var translateParams = { total: valuesArr.length, selected: selectedCount.length };
            var selectAllWrapper = (React.createElement("div", { className: 'select-all-wrapper' },
                React.createElement(Checkbox, { disabled: state.searchTerm ? _this.tp('select-all-disable') : '', value: _this.allSelected(), onChange: _this.onToggleAllSelected }, _this.props.selectAllText || _this.tp('select-all')),
                React.createElement(DeprecatedText, { type: 't4a', className: 'selection-count-details' }, _this.tp('selection-count-details', translateParams))));
            return (React.createElement("div", { className: 'select-all-header' },
                selectAllWrapper,
                React.createElement("div", { className: 'divider' })));
        };
        _this.maybeRenderLimitMsg = function () {
            var props = _this.props;
            var maxSelections = props.maxSelections, asyncSearchItems = props.asyncSearchItems;
            if (maxSelections && !asyncSearchItems && _this.getSelectedCount() >= maxSelections && !props.disableErrorMessage) {
                return (React.createElement(NeutralMessageBox, null, _this.tp('max-selection-reached', { count: maxSelections })));
            }
            else {
                return null;
            }
        };
        _this.renderAsyncSelectedInfo = function () {
            var _a;
            var valuesArr = Array.from(_this.props.value.values());
            var deselect = (React.createElement(Button, { className: 'deselect-all-button', type: 'tertiary', onClick: _this.onDeselect }, _this.tp('deselect-all')));
            var translateParams = {
                total: ((_a = _this.props.asyncSearchItems) === null || _a === void 0 ? void 0 : _a.totalValues) || valuesArr.length,
                selected: _this.getSelectedCount()
            };
            var selectAllWrapper = (React.createElement("div", { className: 'select-all-wrapper' },
                React.createElement(DeprecatedText, { type: 't4a', className: 'selection-count-details' }, _this.tp('selection-count-details', translateParams)),
                _this.getSelectedCount() > 0 ? deselect : null));
            return (React.createElement("div", { className: 'select-all-header' }, selectAllWrapper));
        };
        return _this;
    }
    CheckboxGroup.prototype.render = function () {
        var _a = this, props = _a.props, state = _a.state;
        var _b = props.autoFocus, autoFocus = _b === void 0 ? true : _b, asyncSearchItems = props.asyncSearchItems;
        var showHeader = !this.state.hasHeaders && props.items.length >= this.minItemsForSearch;
        var showSelectAllHeader = showHeader && !asyncSearchItems;
        var classNames = namespacedClassnames(CheckboxGroupKey, props.className, {
            'has-header': showHeader || !!asyncSearchItems,
            'has-select-all-header': showSelectAllHeader,
            scrolled: state.isScrolled
        });
        return (React.createElement("div", { className: classNames },
            React.createElement(SearchContainer, { query: state.searchTerm, onChange: this.onSearchTermChange, hideSearchBar: !showHeader && !asyncSearchItems, autoFocus: autoFocus, placeholder: this.props.searchPlaceholder },
                React.createElement("div", { className: 'checkbox-group-content' },
                    showSelectAllHeader ? this.renderSelectAllHeader() : null,
                    !!asyncSearchItems ? this.renderAsyncSelectedInfo() : null,
                    this.maybeRenderLimitMsg(),
                    this.renderCheckboxes()))));
    };
    return CheckboxGroup;
}(React.PureComponent));
export { CheckboxGroup };
//# sourceMappingURL=index.js.map